module.exports = __webpack_public_path__ + "img/1.dec32e6d.png";